<template>
    <div>
        <div v-if="!search_result_is_empty">
            <Masonry
                    ref="masonry"
                    component="RoomCard"
                    :plan_board="!!list_id"
                    :list_id="list_id"
                    :append_promise="append_promise"
                    @loaded="is_connecting = false"
                    @result_is_empty="search_result_is_empty = true"
                    @can_not_loading_anymore="can_not_loading_anymore = true"
            />
        </div>
        <div v-else class="result_is_empty">
            検索結果が存在しません
        </div>
    </div>
</template>
<script>
    import Masonry from '../components/Masonry'
    import Ajax from '../assets/js/Ajax'
    import Util from '../assets/js/Util'

    export default {
        name: "RoomCardList",
        props: {
            sukikamo_items: {
                type: Array,
                default: () => []
            },
            list_id: {
                type: String,
                default: ''
            }
        },
        components: {
            Masonry
        },
        data: () => ({
            append_promise: null,
            is_connecting: false,
            search_result_is_empty: false,
            can_not_loading_anymore: false,
            loaded_item_num: 0,
            loading_item_num: 30,
        }),
        computed: {
        },
        created() {
            this.is_connecting = false;
            this.append();
        },
        mounted() {
            document.addEventListener('scroll', this.scrollHandler);
        },
        beforeDestroy() {
            document.removeEventListener('scroll', this.scrollHandler);
        },
        watch: {
            sukikamo_items() {
                this.reset();
            },
        },
        methods: {
            append() {
                if (this.is_connecting || this.can_not_loading_anymore) return;
                this.is_connecting = true;
                this.append_promise = new Promise( r => r( this.sukikamo_items.slice(this.loaded_item_num, this.loaded_item_num + this.loading_item_num) ) );
                this.loaded_item_num += this.loading_item_num;
            },
            scrollHandler() {
                const scrolled_to_the_bottom = Util.checkIfUserScrolledToTheBottom();
                if ( scrolled_to_the_bottom ) this.append();
            },
            async reset() {
                this.is_connecting = false;
                this.search_result_is_empty = false;
                this.can_not_loading_anymore = false;
                this.loaded_item_num = 0;
                this.append_promise = null;
                if ( this.$refs.masonry ) await this.$refs.masonry.reset();
                this.append();
            },
        }
    }
</script>

<style scoped lang="scss">
    .result_is_empty{
        text-align: center;
        height: 90vh;
    }
</style>
